import ActionTypes from "./ActionTypes";

const pagesData = (payload) => {
  return {
    type: ActionTypes.GET_PAGES,
    payload,
  };
};

const lotNumberData = (payload) => {
  return {
    type: ActionTypes.GET_LOT_NUMBER,
    payload,
  };
};

export { pagesData, lotNumberData };
